import "./Error.scss";
export function Error({ error }) {
  return (
    <div className="Error">
      Sorry, an error occured:
      <br /> {error.message}
    </div>
  );
}
